export interface Voucher {
  id: number;
  description: string;
  expirationDate: string;
  info: VoucherInformation;
  totalAmount: number;
  entries: VoucherEntry[];
}

interface VoucherInformation {
  address: string;
  agentName: string;
  commune: string;
}

export interface VoucherEntry {
  description: string;
  amount: number;
}

export const DefaultVoucher: Voucher = {
  id: -1,
  description: "Default",
  expirationDate: "",
  info: {
    address: "Default",
    commune: "Default",
    agentName: "Default",
  },
  totalAmount: 0,
  entries: [{ description: "Default", amount: 0 }],
};
